import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _dec, _obj;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import util from '@utils/util';
import { LMClick } from '@utils/LMEvent';
import videoService from '@services/videoService';
import webLogin from '@utils/weblogin';
export default {
  name: 'Authorization',
  props: {
    authentication: Object
  },
  data: function data() {
    return {
      VideoAPIService: null,
      gold: 0,
      diamond: 0
    };
  },
  created: function created() {
    this.updateAuthentication();
  },
  watch: {
    authentication: function authentication() {
      this.updateAuthentication();
    }
  },
  filters: {
    format: function format(value) {
      if (typeof value === 'number') {
        return util.nFormatter(value, 1);
      }
      return "".concat(value);
    }
  },
  methods: (_dec = LMClick('Live-Room'), _obj = {
    updateAuthentication: function updateAuthentication() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.isAuthenticated(_this.authentication)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this.VideoAPIService = videoService.createApi();
              _context.next = 5;
              return _this.VideoAPIService.getWallet(_this.authentication).catch(function (e) {
                if (e.status === 200 && e.data && e.data.status === '402') {
                  webLogin.reset();
                  _this.isAuthenticated(webLogin.getAuthentication());
                  _this.$lmBus && _this.$lmBus.$emit('Header-Login-Out-Handle');
                  _this.$emit('authenticate');
                }
              });
            case 5:
              wallet = _context.sent;
              if (wallet) {
                _this.gold = +(wallet.gold || 0);
                _this.diamond = +(wallet.diamond || 0);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getWallet: function getWallet() {
      return {
        gold: this.gold,
        diamond: this.diamond
      };
    },
    updateWalletSync: function updateWalletSync(gold, diamond) {
      if (gold !== void 0) {
        this.gold = gold;
      }
      if (diamond !== void 0) {
        this.diamond = diamond;
      }
    },
    isAuthenticated: function isAuthenticated(authentication) {
      return !!authentication && !!authentication.uid;
    },
    rechargeHandler: function rechargeHandler() {
      util.KEWLSensorTrack({
        lmweb_clickText: '直播间充值',
        lmweb_tabName: 'pc'
      });
      this.$emit('recharge');
    },
    loginHandler: function loginHandler() {
      this.$emit('authenticate');
    }
  }, _applyDecoratedDescriptor(_obj, "loginHandler", [_dec], Object.getOwnPropertyDescriptor(_obj, "loginHandler"), _obj), _obj)
};